
//================================================================================
// 28Th Oct, 2025 src/components/tenantcomponents/LegalAgreements/TenantMSA.js
//================================================================================
import React from 'react';
import { Typography, Box, List, ListItem } from '@mui/material';

const TenantMSA = () => (
  <Box sx={{ maxHeight: '400px', overflow: 'auto', p: 2, border: '1px solid #ccc' }}>
    <Typography variant="h6" gutterBottom>
      MEDICERP MASTER SERVICES AGREEMENT
    </Typography>
    
    <Typography variant="body2" paragraph>
      <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>1. SERVICES PROVIDED</strong><br/>
      MedicERP provides a server-hosted, software-as-a-service (SaaS) pharmacy management system delivered via third-party hosting (for example Railway for backend and Vercel for frontend). Features include but are not limited to:
      - Inventory Management
      - Purchase, Sales & Billing (including GST calculation)
      - Accounting & Financial Reporting
      - Customer/Patient Management and Prescription Records
      - Equity/share capital and opening stock management
      - Other related modules forming a near-complete pharmacy management package
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>2. DATA OWNERSHIP & RESPONSIBILITIES</strong><br/>
      2.1 You retain all rights to your business data<br/>
      2.2 You are responsible for data accuracy and regulatory compliance<br/>
      2.3 You must maintain proper pharmacy licenses and permits<br/>
      2.4 You are solely responsible for prescription validations<br/>
      2.5 Backups & data loss: MedicERP does not guarantee against data loss. You must maintain your own regular backups of business data; MedicERP may provide an online backup service in future.<br/>
      2.6 Force majeure / third-party outages: MedicERP will not be liable for loss of data or service interruptions caused by force majeure events, hosting provider outages, acts of government, or other events outside MedicERP’s reasonable control.<br/>
      2.7 During the free/trial period, MedicERP provides no SLA, no uptime 
          guarantee, and no data backup guarantee. The subscriber accepts full 
          responsibility for maintaining independent backups of all business data.<br/>
      2.8 MedicERP may discontinue, modify, or suspend the service at any time 
          during the trial period with 7 days' notice (or immediately in case of 
          abuse or legal risk).<br/>
      2.9 Trial accounts may be migrated, reset, or deleted at MedicERP's 
          discretion for technical or business reasons.<br/>
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>3. LIMITATION OF LIABILITY</strong><br/>
      3.1 MedicERP is not liable for business decisions made using the software.<br/>
      3.2 Except as required by law, MedicERP’s maximum aggregate liability is limited to six (6) months of subscription fees paid under this Agreement.<br/>
      3.3 MedicERP is not responsible for third-party integrations or for data breaches resulting from user negligence or misconfiguration.<br/>
      3.4 THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY 
          OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES 
          OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR UNINTERRUPTED 
          AVAILABILITY.<br/>
      3.5 MEDICERP MAKES NO GUARANTEE OF UPTIME, DATA RETENTION, OR SYSTEM 
          AVAILABILITY<br/>
      3.6 IN NO EVENT SHALL MEDICERP BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
          SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOSS OF DATA, 
          REVENUE, OR BUSINESS OPPORTUNITY.<br/>

    </Typography>

    <Typography variant="body2" paragraph>
      <strong>4. TERMINATION</strong><br/>
      4.1 30-day notice period for termination by either party.<br/>
      4.2 Data export available for 60 days post-termination; it is the firm's responsibility to export and retain backups before the 60-day window expires.<br/>
      4.3 Immediate termination for regulatory violations, fraud, or material breach.
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>5. GOVERNING LAW</strong><br/>
      This agreement shall be governed by the laws of India and the parties submit to the exclusive jurisdiction of the courts of Jammu & Kashmir, India.
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>6. INDEMNITY</strong><br/>
      You agree to indemnify, defend and hold harmless MedicERP and its officers, employees and agents from any losses, claims, liabilities or expenses arising from (a) your misuse of the service, (b) your regulatory non-compliance, (c) incorrect data entry, or (d) breach of user credentials or policies caused by your personnel.
    </Typography>
    <Typography variant="body2" paragraph>
      <strong>Section 7: BETA/TRIAL DISCLAIMER</strong><br/>
      7.1 The subscriber acknowledges that the service is in an active development 
          and trial phase. Features may change, be removed, or malfunction without 
          notice.<br/>
      7.2 No financial compensation will be offered for service interruptions, 
          data loss, or feature changes during the trial period.<br/>
      7.3 Continued use of the service after receiving notice of changes constitutes 
          acceptance of those changes.<br/>
     </Typography>
  </Box>
);
export default TenantMSA;